/** Product feeds (Google Merchant XML, Meta CSV) per currency + rotate the secret token. */
import React, { useEffect, useState } from 'react';
import { Button, Card, Empty, Popconfirm, Result, Table, Typography, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../shared/i18n';
import { QUIET } from './api';
import { CopyLine, Hint, listOf, toastErr, useSite } from './common';

const { Text } = Typography;

const ShopFeeds = () => {
    const { t } = useTranslation();
    const { api } = useSite();
    const [feeds, setFeeds] = useState(null);
    const [soon, setSoon] = useState(false);
    useEffect(() => {
        api.get('/feeds', null, QUIET).then((d) => setFeeds(listOf(d?.feeds || d))).catch((e) => { if (e?.status === 404) setSoon(true); else toastErr(e); setFeeds([]); });
    }, [api]);
    const rotate = async () => {
        try { const d = await api.post('/feeds/rotate'); setFeeds(listOf(d?.feeds || d)); message.success(t('New links created — update them in Google and Meta')); } catch (e) { toastErr(e); }
    };
    if (soon) return <Card><Result status="info" title={t('Product feeds are coming soon')} /></Card>;
    return (
        <Card size="small" title={<span>{t('Product feeds')}<Hint title={t('Paste these links into Google Merchant Center or Meta Commerce Manager')} /></span>}
            extra={<Popconfirm title={t('The old links stop working. Continue?')} onConfirm={rotate}><Button size="small" icon={<ReloadOutlined />}>{t('New links')}</Button></Popconfirm>}>
            <Table rowKey="currency" size="small" loading={!feeds} dataSource={feeds || []} pagination={false} scroll={{ x: 700 }}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                columns={[
                    { title: t('Currency'), dataIndex: 'currency', width: 90, render: (v) => <Text strong>{v}</Text> },
                    { title: 'Google (XML)', dataIndex: 'google', render: (v) => <CopyLine value={v} /> },
                    { title: 'Meta (CSV)', dataIndex: 'meta', render: (v) => <CopyLine value={v} /> },
                ]} />
        </Card>
    );
};

export default ShopFeeds;
